// Check if running in browser environment
const isBrowser = typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export const clearStoredAuth = () => {
  if (!isBrowser) return;

  window.localStorage.removeItem('token');
  window.localStorage.removeItem('user');
};

const decodeTokenPayload = (token) => {
  const encodedPayload = token.split('.')[1];
  if (!encodedPayload) return null;

  const normalizedPayload = encodedPayload.replace(/-/g, '+').replace(/_/g, '/');
  const paddedPayload = normalizedPayload.padEnd(Math.ceil(normalizedPayload.length / 4) * 4, '=');
  return JSON.parse(window.atob(paddedPayload));
};

/**
 * Check if user is authenticated
 * @returns {boolean} True if user is authenticated, false otherwise
 */
export const isAuthenticated = () => {
  // Skip check during server-side rendering
  if (!isBrowser) return false;
  
  try {
    const token = window.localStorage.getItem('token');
    if (!token) return false;

    const payload = decodeTokenPayload(token);
    if (!payload?.exp || payload.exp <= Math.floor(Date.now() / 1000)) {
      clearStoredAuth();
      return false;
    }

    return true;
  } catch (error) {
    clearStoredAuth();
    if (process.env.NODE_ENV !== 'production') {
      console.error('Authentication check failed:', error);
    }
    return false;
  }
};

/**
 * Get current user data from localStorage
 * @returns {Object|null} User object or null if not authenticated
 */
export const getCurrentUser = () => {
  // Skip during server-side rendering
  if (!isBrowser) return null;
  
  try {
    const user = window.localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Error getting current user:', error);
    }
    return null;
  }
};
